"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerKit = exports.ServerKitFactory = void 0;
const noteBase_1 = require("../marks/noteBase");
const qmsInlineCommentMark_1 = require("../marks/qmsInlineCommentMark");
const emoji_1 = require("../nodes/emoji");
const file_1 = require("../nodes/file");
const image_1 = require("../nodes/image");
const reference_1 = require("../nodes/reference");
const embed_1 = require("../nodes/embed");
const kit_1 = require("../kit");
const tiptapExtensions_1 = require("../tiptapExtensions");
const common_kit_1 = require("./common-kit");
const ServerKitFactory = (e) => ({
    ...(0, common_kit_1.CommonKitFactory)(e),
    // ==========================================================================================
    // Extensions and kits with separate / extended implementations in the client-side editor kit
    // See file://./../../../../plugins/text-editor-resources/src/kits/editor-kit.ts
    // =============================================================================
    lists: e(common_kit_1.ListKit),
    codeSnippets: e(common_kit_1.CodeSnippetsKit),
    tables: e(common_kit_1.TableKit),
    textColorStyling: e(common_kit_1.TextColorStylingKit),
    hardBreak: e(tiptapExtensions_1.HardBreak),
    reference: e(reference_1.ReferenceNode),
    file: e(file_1.FileNode),
    image: e(image_1.ImageNode),
    embed: e(embed_1.EmbedNode),
    emoji: e(emoji_1.EmojiNode),
    inlineNote: e(noteBase_1.NoteBaseExtension), // Semi-deprecated, should be removed in the future
    qmsInlineCommentMark: e(qmsInlineCommentMark_1.QMSInlineCommentMark) // Semi-deprecated, should be removed in the future
});
exports.ServerKitFactory = ServerKitFactory;
exports.ServerKit = (0, kit_1.extensionKit)('server-kit', exports.ServerKitFactory);
//# sourceMappingURL=server-kit.js.map